import React, { forwardRef } from "react";
import {
  Textarea,
  TextareaProps,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Box,
} from "@chakra-ui/react";

interface KYDTextAreaProps extends TextareaProps {
  error?: string;
  label?: string;
}

const KYDTextArea = forwardRef<HTMLTextAreaElement, KYDTextAreaProps>(
  (
    {
      error,
      placeholder,
      border = "1px solid #E2E8F0",
      borderRadius = "8px",
      minHeight = "50px",
      width = "100%",
      resize = "vertical",
      label,
      ...props
    },
    ref
  ) => (
    <FormControl isInvalid={!!error} width={width}>
      <Box border={border} borderRadius={borderRadius} p={3} pb={1}>
        {label && (
          <FormLabel
            mb={1}
            fontSize="12px"
            fontWeight="400"
            color="#00000080"
            letterSpacing="-0.03em"
          >
            {label}
          </FormLabel>
        )}
        <Textarea
          placeholder={placeholder}
          border="none"
          borderRadius="none"
          minHeight={minHeight}
          width="100%"
          resize={resize}
          _placeholder={{ color: "#00000080" }}
          fontFamily="Helvetica"
          fontSize="14px"
          p={0}
          _focus={{ outline: "none", boxShadow: "none" }}
          ref={ref}
          {...props}
        />
      </Box>
      {error && (
        <FormErrorMessage fontSize="12px" color="red">
          {error}
        </FormErrorMessage>
      )}
    </FormControl>
  )
);

export default KYDTextArea;
